<template>
  <div>
    <user-list v-show="tabType === 1" @handleShow="handleShow"  />
    <login-log v-if="tabType === 2 " @handleShow="handleShow" :rowItem="rowItem"  />
  </div>
</template>

<script>
import userList from './list.vue'
import loginLog from './loginLog.vue'
export default {
  components: { userList, loginLog },
  data() {
    return {
      tabType: 1,
      rowItem: null
    }
  },
  methods: {
    handleShow(row, type) {
      this.rowItem = { ...row }
      this.tabType = type
    }
  }


}
</script>

<style>
</style>